import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TextClampUtilitiesService {
  public isTextClamped(element: ElementRef<HTMLElement> | HTMLElement | undefined): boolean {
    if (!element) {
      return false;
    }

    const nativeElement = element instanceof ElementRef ? element.nativeElement : element;
    const isClamped =
      nativeElement.scrollHeight > nativeElement.clientHeight || nativeElement.scrollWidth > nativeElement.clientWidth;

    return isClamped;
  }
}
